import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { isSvgOrPng } from '../../../utils/helpers';
import { OSConfig, VpsAppConfig } from '../utils/types';
import LetterAvatar from './LetterAvatar';

const AppLogo: React.FC<{
  logoConfig: VpsAppConfig | OSConfig;
  variant?: 'small' | 'large';
  spacing?: number;
}> = ({ logoConfig, variant = 'large', spacing }) => {
  const { name, logo, logoAlt } = logoConfig;
  const isSvgOrPngLogo = isSvgOrPng(logo);
  const logoSize = { width: 30, height: 30 };
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {isSvgOrPngLogo ? (
        <Box
          component="img"
          src={logo}
          alt={logoAlt}
          width={logoSize.width}
          height={logoSize.height}
        />
      ) : (
        <LetterAvatar letters={logo} />
      )}
      <Typography variant={variant === 'small' ? 'body2' : 'h3'}>
        {name}
      </Typography>
    </Stack>
  );
};

export default AppLogo;
